import { useConfigContext } from "@/state/configContext";
import { assert } from "@/helpers/helpers";
import { GET } from "@/state/api";
import { POST, server } from "@/state/server";
import type { UbicacionZod } from "@/state/types";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { z } from "zod";

const SearchZod = z.object({ temporada_id: z.coerce.number().optional() });

export const Route = createFileRoute("/admin/ubicaciones")({
  component: RouteComponent,
  validateSearch: SearchZod,
  loader: async () => (await GET("/admin/fotografos/ubicaciones")).ubicaciones,
});

function RouteComponent() {
  const search = Route.useSearch();
  const config = useConfigContext();
  const router = useRouter();
  const ubicaciones_data = Route.useLoaderData();

  const temporada =
    config.temporadas[search.temporada_id || 0] ??
    config.temporadas[config.temporada];
  assert(temporada);

  const [ubicaciones, setUbicaciones] = useState<
    z.infer<typeof UbicacionZod>[]
  >([]);

  useEffect(() => {
    const u = ubicaciones_data[temporada.id];
    if (u) setUbicaciones(u);
  }, [temporada.id, !!ubicaciones_data]);

  return (
    <div>
      <select
        value={temporada.id}
        onChange={(e) =>
          router.navigate({
            to: "/admin/ubicaciones",
            search: { temporada_id: Number(e.target.value) },
          })
        }
      >
        {Object.values(config.temporadas)
          .sort((a, b) => b.prioridad - a.prioridad)
          .map(({ id, nombre }) => (
            <option value={id} key={id}>
              {nombre}
            </option>
          ))}
      </select>
      {
        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                <th>Fotografo</th>
                <th>Ubicación</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {ubicaciones.map((u) => (
                <tr key={u.fotografo_id}>
                  <td>
                    {u.numero}.- {config.fotografos[u.fotografo_id].nombre}
                  </td>
                  <td>
                    <select
                      value={u.lugar_id || 0}
                      onChange={(e) =>
                        setUbicaciones(
                          ubicaciones.map((x) =>
                            x.id == u.id
                              ? { ...u, lugar_id: Number(e.target.value) }
                              : x
                          )
                        )
                      }
                    >
                      <option />
                      {temporada.lugares.map((l) => (
                        <option value={l.id} key={l.id}>
                          {l.name}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <a
                      href={`${server}/subidor.cfg?fotografo=${u.fotografo_id}&temporada=${temporada.id}`}
                    >
                      subidor.cfg
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      }
      <button
        onClick={() =>
          POST("/admin/fotografos/ubicaciones", {
            ubicaciones: Object.fromEntries(
              ubicaciones
                .filter((x) => x.lugar_id)
                .map((x) => [x.id, x.lugar_id])
            ),
          })
        }
      >
        Enviar
      </button>
    </div>
  );
}
